import Repository from "@/app/repository/repository-factory";

const WalletRepository = Repository.get("WalletRepository");

export default {
  state: {
    walletOwner: null,
    wallet: {
      walletId: null,
      personalAccountBalance: 0,
      onePercentAccountBalance: 0,
      publicAccountBalance: 0,
      overallBalance: 0,
      foundationAccountBalance: 0,
      version: null
    },
    grid: {
      items: [],
      info: {
        countAllItems: 0,
        currentPage: 1,
        maxItemsPerPage: 10,
      },
      filterAndSearch: {
        search: '',
        dateFrom: null,
        dateTo: null
      },
      sort: {
        sortBy: 'createdAt',
        sortDesc: true,
      },
    }
  },
  getters: {
    GET_WALLET: (state) => {
      return state.wallet;
    },
    GET_PERSONAL_ACCOUNT_BALANCE: (state) => {
      return state.wallet.personalAccountBalance;
    },
    GET_ONE_PERCENT_ACCOUNT_BALANCE: (state) => {
      return state.wallet.onePercentAccountBalance;
    },
    GET_PUBLIC_ACCOUNT_BALANCE: (state) => {
      return state.wallet.publicAccountBalance;
    },
    GET_OVERALL_BALANCE: (state) => {
      return state.wallet.overallBalance;
    },
    GET_FOUNDATION_ACCOUNT_BALANCE: (state) => {
      return state.wallet.foundationAccountBalance;
    },
  },
  mutations: {
    SET_WALLET_OWNER: (state, payload) => {
      state.walletOwner = payload;
    },
    SET_WALLET: (state, payload) => {
      state.wallet = payload;
    },
  },
  actions: {
    WALLET_OWNER: ({ commit, dispatch }, walletOwner) => {
      dispatch("WALLET_CLEAR");
      commit('SET_WALLET_OWNER', walletOwner);
    },
    GET_WALLET_BY_OWNER: async ({ commit, state }) => {

      if (state.walletOwner === null) {
        return;
      }

      let { data } = await WalletRepository.getWalletByOwner(state.walletOwner);

      commit('SET_WALLET', {
        walletId: data.walletId,
        personalAccountBalance: data.personalAccountBalance,
        onePercentAccountBalance: data.onePercentAccountBalance,
        publicAccountBalance: data.publicAccountBalance,
        overallBalance: data.overallBalance,
        foundationAccountBalance: data.foundationAccountBalance,
        version: data.version
      });

      return state.grid.items;
    },
    WALLET_PAY_OUT: async ({ state }, { walletType, amount, time, documentDetails, comments }) => {

      let payload = {
        walletType: walletType,
        amount: parseFloat(amount),
        time: time,
        documentDetails: documentDetails,
        comments: comments
      };

      let { data } = await WalletRepository.payOut(state.wallet.walletId, payload);

      return data;
    },
    WALLET_PAY_IN: async ({ state }, { walletType, amount, time, payer, depository }) => {

      let payload = {
        walletType: walletType,
        amount: parseFloat(amount),
        time: time,
        payer: payer,
        depository: depository,
      };

      let { data } = await WalletRepository.payIn(state.wallet.walletId, payload);

      return data;
    },
    WALLET_OPERATION_CORRECTION: async ({ state }, { operationUuid, newAmount, reasonCorrect }) => {

      let payload = {
        newAmount: parseFloat(newAmount),
        reasonCorrect: reasonCorrect,
        walletVersion: state.wallet.version,
      };

      let { data } = await WalletRepository.correctOperation(state.wallet.walletId, operationUuid, payload);

      return data;
    },
    WALLET_CLEAR: ({ commit }) => {
      commit("SET_WALLET_OWNER", null);
      commit("SET_WALLET", {
        walletId: null,
        personalAccountBalance: 0,
        onePercentAccountBalance: 0,
        publicAccountBalance: 0,
        overallBalance: 0,
        foundationAccountBalance: 0,
        version: null
      });
    },
  },
}
